<script lang="ts">
export default {
    name: 'BaseCircleLoading',
};
</script>

<script lang="ts" setup>
import { computed } from 'vue-demi';

interface Props {
    /**
     * colorful为false的时候loading是白色
     */
    colorful?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    colorful: true,
});

const circleType = computed(() => ['circle', props.colorful && 'circle-dark']);
</script>

<template>
    <span :class="circleType" />
</template>

<style lang="scss" scoped>
.circle {
    display: inline-block;
    width: 1em;
    height: 1em;
    background-image: url('./assets/circle.png');
    background-size: 100% 100%;
    animation: rolling 1s linear infinite;
}
.circle-dark {
    background-image: url('./assets/circle_dark.png');
}

@keyframes rolling {
    100% {
        transform: rotate(-360deg);
    }
}
</style>
